import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Paper,
  CircularProgress,
  TextField,
  InputAdornment,
} from '@mui/material';
import Search from '@mui/icons-material/Search';
import { fetchNotifications, markNotificationRead } from '../../store/slices/notificationsSlice';

export default function Notifications() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list: notifications, loading } = useSelector((s) => s.notifications);
  const [searchQuery, setSearchQuery] = useState('');

  const getNotificationLabel = (n) => {
    if (n.type === 'post_pending_review') return 'Article en attente de validation';
    if (n.type === 'partnership_end') return 'Partenariat terminé';
    return n.type || '';
  };

  const filtered = !searchQuery.trim()
    ? notifications
    : notifications.filter((n) => {
        const q = searchQuery.toLowerCase();
        const type = getNotificationLabel(n).toLowerCase();
        const title = (n.relatedPost?.title || '').toLowerCase();
        const partnerName = (n.relatedPartnership?.name || '').toLowerCase();
        return type.includes(q) || title.includes(q) || partnerName.includes(q);
      });

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  const handleClick = async (n) => {
    if (!n.read) await dispatch(markNotificationRead(n._id));
    if (n.relatedPost?._id) navigate(`/dashboard/posts/edit/${n.relatedPost._id}`);
    if (n.type === 'partnership_end' && n.relatedPartnership?._id) {
      navigate(`/dashboard/partnerships/edit/${n.relatedPartnership._id}`);
    }
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>Notifications</Typography>
      <TextField
        size="small"
        placeholder="Rechercher par type, titre ou partenaire…"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
        }}
        sx={{ mb: 2, minWidth: 280, maxWidth: 400 }}
      />
      <Paper sx={{ borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
        <List disablePadding>
          {filtered.length === 0 && !loading && (
            <ListItem><ListItemText primary={notifications.length === 0 ? 'Aucune notification.' : 'Aucun résultat pour cette recherche.'} /></ListItem>
          )}
          {filtered.map((n) => (
            <ListItemButton key={n._id} onClick={() => handleClick(n)} sx={{ bgcolor: n.read ? 'transparent' : 'action.hover' }}>
              <ListItemText
                primary={getNotificationLabel(n)}
                secondary={
                  n.relatedPost?.title
                    ? `Article : ${n.relatedPost.title}`
                    : n.type === 'partnership_end' && n.relatedPartnership?.name
                    ? `Partenariat : ${n.relatedPartnership.name}`
                    : new Date(n.createdAt).toLocaleString('fr-FR')
                }
              />
            </ListItemButton>
          ))}
        </List>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
            <CircularProgress />
          </Box>
        )}
      </Paper>
    </Box>
  );
}
